import {
  Prize,
  UserOpenBrokerStatus,
  WHEEL_PRIZE_LIST,
} from "@/interfaces/pullNewType";
import PullNewServices from "@/service/pullNew.service";
import ActivityContext from "@/utils/actiivityContext";
import clientDeepLinks from "@/utils/clientDeepLinks";
import directToClientLogin from "@/utils/directToClientLogin";
import getConfetti from "@/utils/getConfetti";
import handleDeepLink from "@/utils/handleDeepLink";
import hasLogin from "@/utils/hasLogin";
import { useRouter } from "next/router";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import OpenAccountModal from "./OpenAccountModal";
import PrizeModal from "./PrizeModal";
import SpinWheel from "./SpinWheel";

interface SpinPrizeProps {
  opportunities: number;
  visible: boolean;
  onSpinSuccess: () => void;
  onHidden: () => void;
  onShare?: () => void;
}

export default function SpinPrize({
  opportunities,
  visible,
  onHidden,
  onShare,
  onSpinSuccess,
}: SpinPrizeProps) {
  const router = useRouter();
  const activityInfo = useContext(ActivityContext);
  const [sping, setSping] = useState(false);
  const [spinVisible, setSpinVisible] = useState(false);
  const [prizeVisible, setPrizeVisible] = useState(false);
  const [openAccountVisible, setOpenAccountVisible] = useState(false);
  const [prize, setPrize] = useState<Prize | undefined>(undefined);

  const spinPrizeRef = useRef<any>();

  useEffect(() => {
    setSpinVisible(visible);
  }, [visible]);

  const getPrizeResult = async () => {
    try {
      const data = await PullNewServices.getPrizeResult();
      const prize = WHEEL_PRIZE_LIST.find((item) => item.awardId === data);

      setPrize(prize);
      const prizeIndex = WHEEL_PRIZE_LIST.findIndex(
        (item) => item.awardId === data
      );

      spinPrizeRef.current.wheel.current.stop(
        prizeIndex > -1 ? prizeIndex : -1
      );
    } catch (error) {
      spinPrizeRef.current.wheel.current.stop(-1);
    }
  };

  // 开始转动
  const handleStartWheel = () => {
    const canSpin = checkCanSpin();
    if (!canSpin) {
      return;
    }

    setSping(true);
    spinPrizeRef.current.wheel.current.play();
    getPrizeResult();
  };
  // 停止转动
  const handleStopWheel = async (prizeIndex: number) => {
    if (prizeIndex > -1) {
      console.log(prizeIndex);
      onSpinSuccess();
      setPrizeVisible(true);
      handleConfetti();
    }
    setSping(false);
  };

  // 彩带
  const handleConfetti = useCallback(() => getConfetti(), []);

  // 奖励弹框按钮
  const handlePrizeModalBtnClick = () => {
    if (isContinue()) {
      setSpinVisible(true);
      handleStartWheel();
    } else {
      // 跳转邀请页
      router.push("/activities/holiday2022/invitee");
      onHidden();
    }
  };

  // 是否可以继续
  const isContinue = () => opportunities > 0;

  // 抽取奖励检查
  const checkCanSpin = () => {
    if (!hasLogin()) {
      directToClientLogin();
      return false;
    }

    if (!isContinue()) {
      onShare && onShare();
      return false;
    }

    if (activityInfo?.userStatus === UserOpenBrokerStatus.NO_COMMIT_MATERIAL) {
      setOpenAccountVisible(true);
      return false;
    }

    return !sping;
  };

  return (
    <>
      <SpinWheel
        ref={spinPrizeRef}
        opportunities={opportunities}
        visible={spinVisible}
        onClose={() => {
          setSpinVisible(false);
          onHidden();
        }}
        onSpin={handleStartWheel}
        onEnd={handleStopWheel}
      />
      <PrizeModal
        visible={prizeVisible}
        prize={prize}
        isContinue={isContinue()}
        onClose={() => {
          setPrizeVisible(false);
          onHidden();
        }}
        onBtnClick={() => {
          setPrizeVisible(false);
          handlePrizeModalBtnClick();
        }}
      />

      <OpenAccountModal
        visible={openAccountVisible}
        onClose={() => setOpenAccountVisible(false)}
        onConfirm={() => {
          setOpenAccountVisible(false);
          handleDeepLink(clientDeepLinks.assetPage());
          onHidden();
        }}
      />
    </>
  );
}
